import getInstance from './config';

export default class ContactApi {
  static async createContact(emailData) {
    const instance = await getInstance();
    const { data } = await instance.post('/contact/send-mail-monjolinho', emailData);
    return data;
  }
}
